import { Tooltip } from '@contentful/forma-36-react-components';
import { PropsWithChildren } from 'react';

type TooltipSwitchProps = PropsWithChildren<{ show: boolean; content: string }>;

export const TooltipSwitch = ({ show, content, children }: TooltipSwitchProps) =>
  show ? <Tooltip content={content}>{children}</Tooltip> : <>{children}</>;
